import { baseApi } from "../../../shared/api/baseApi"
import { IFormInputs } from "../model/create/CreateInterwiew"
import { IInterviewer } from "../model/create/CreateInterwiewer"

export const interviewsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllInterviews: build.query<any, any>({
      query: (params) => ({
        url: `getScheduleInterview?pageNumber=${params}`,
        method: "GET",
      }),
      providesTags: ["Interviews"],
    }),
    getInterviewer: build.query<any, any>({
      query: (page) => ({
        url: `getInterviewer?pageNumber=${page}`,
        method: "GET",
      }),
      providesTags: ["Interviews", "TimeSlots"],
    }),
    addScheduleInterview: build.mutation<any, any>({
      query: (formData) => {
        return {
          url: `addScheduleInterview`,
          method: "POST",
          body: formData,
        }
      },
      invalidatesTags: ["TimeSlots", "Interviews"],
    }),
    updateScheduleInterview: build.mutation<any, any>({
      query: (formData) => ({
        url: `updateScheduleInterview`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["Interviews", "TimeSlots"],
    }),
    addInterview: build.mutation<IFormInputs, any>({
      query: (data) => ({
        url: `addScheduleInterview`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["Interviews", "TimeSlots"],
    }),

    updateInterviewer: build.mutation<IInterviewer, any>({
      query: (data) => ({
        url: `updateInterviewer`,
        method: "PATCH",
        body: { ...data },
      }),
      invalidatesTags: ["Interviews"],
    }),
    getSelect: build.query<any, void>({
      query: () => ({
        url: `getSelect`,
        method: "GET",
      }),
      providesTags: ["Interviews", "Schedule"],
    }),
    getDepartment: build.query<any, any>({
      query: (id) => ({
        url: `getDepartment?id=${id}`,
        method: "GET",
      }),
      providesTags: ["Interviews"],
    }),
    getLine: build.query<any, any>({
      query: (id) => ({
        url: `getLine?id=${id}`,
        method: "GET",
      }),
      providesTags: ["Interviews"],
    }),
    getScheduleSelect: build.query<any, any>({
      query: (params) => ({
        url: `getScheduleSelect?${params}`,
        method: "GET",
      }),
      providesTags: ["Interviews", "Schedule"],
    }),
    getTimeSlotsSelect: build.query<any, any>({
      query: (params) => ({
        url: `getTimeSlotsSelect?${params}`,
        method: "GET",
      }),
      providesTags: ["Interviews"], // возможно добавить нужно что-то
    }),
    // uploadFile: build.mutation<void, FormData>({
    //   query: (formData) => {
    //     return {
    //       url: `file`,
    //       method: "POST",
    //       body: formData,
    //     }
    //   },
    // }),
  }),
})

export const {
  useGetAllInterviewsQuery,
  useAddScheduleInterviewMutation,
  useGetSelectQuery,
  useUpdateInterviewerMutation,
  useGetInterviewerQuery,
  useGetDepartmentQuery,
  useGetLineQuery,
  useGetScheduleSelectQuery,
  useGetTimeSlotsSelectQuery,
  useUpdateScheduleInterviewMutation,
  // useUploadFileMutation,
} = interviewsApi
